import { TextInput } from '@mantine/core';
import { Search } from '@material-ui/icons';
import GoogleMap from 'components/GoogleMap';
import React, { useLayoutEffect, useState } from 'react';
import { useEffect } from 'react';

const Location = ({ office = [] }) => {
  const [officeState, setOfficeState] = useState([]);
  const [officeSearch, setOfficeSearch] = useState([]);
  const [focusLoction, setFocusLocation] = useState(null);
  const [windowReference, setWindowReference] = useState(null);

  const handleSeachLocation = (event) => {
    const { value } = event.target;
    const result = officeState.filter((i) =>
      i.address.toLowerCase().includes(value.toLowerCase().trim())
    );
    setOfficeSearch(result);
  };
  const handleRedirect = (office) => {
    const position = office.position.split(', ');
    windowReference.open(`https://www.google.com/maps/place/${position[1]},${position[0]}`, '_blank');
    setFocusLocation(office);
  };
  const handleChooseOffice = (office) => {
    setFocusLocation(office);
  };

  useEffect(() => {
    setOfficeState(office);
    setOfficeSearch(office);
  }, [office]);

  useLayoutEffect(() => {
    if (window) {
      setWindowReference(window);
    }
  }, []);
  return (
    <>
      {office?.length > 0 ? (
        <div className='w-full h-full flex flex-col lg:flex-row'>
          <div className='order-2 lg:order-1 grow w-full lg:w-1/2 h-full mt-3 lg:mt-0 overflow-y-auto'>
            <TextInput
              placeholder='Nhập tên thành phố'
              variant='unstyled'
              icon={<Search />}
              rightSection={<img src='/icon/my_location.png' className='-mr-4 lg:mr-2' />}
              onChange={handleSeachLocation}
            />
            <div className='h-[300px] w-full lg:h-[360px] overflow-y-auto'>
              {officeSearch.map((office, index) => (
                <div key={index} className='flex items-start py-3 lg:px-3'>
                  <img
                    onClick={() => handleChooseOffice(office)}
                    className='w-4 min-w-4'
                    src='/icon/point_location.png'
                    alt=''
                  />
                  <div
                    onClick={() => handleChooseOffice(office)}
                    className='text-7B7B7B px-4 font-roboto-regular text-14px w-full'
                  >
                    <p className='text-left'>{office.address}</p>
                  </div>
                  <img
                    className='w-6 min-w-6 justify-self-end cursor-pointer'
                    src='/icon/direct.png'
                    onClick={() => handleRedirect(office)}
                  />
                </div>
              ))}
            </div>
          </div>
          <div className='order-1 lg:order-2 w-full md:w-1/2 md:min-w-[400px] h-[400px]'>
            <GoogleMap listLocation={office || []} focusLocation={focusLoction} />
          </div>
        </div>
      ) : (
        <div className='flex flex-col items-center'>
          <div className='py-3 px-5 mb-3 bg-E9FCEC border border-8FDFC6 rounded-md w-fit flex items-center font-roboto-regular text-14px'>
            <img className='w-4 h-4' src='/icon/checked.svg' alt='' />
            <p className='ml-3'>Sản phẩm này áp dụng cho mọi địa điểm trên toàn quốc.</p>
          </div>
          <img className='w-[131px] mb-[54px]' src='/assets/images/loyalty/vietnam.svg' alt='' />
        </div>
      )}
    </>
  );
};

export default Location;
